import { Injectable } from "@angular/core"
import { BybitWebsocketClient } from "../../../market"
import { Observable } from "rxjs"
import { Position, PositionSide } from "../../../model/trade"
import { isWsPositionEventV5 } from "libs/bybit-api/src"
import { parseFloatSafe, parseIntSafe } from "src/app/core/func"

@Injectable({
  providedIn: 'root'
})
export class BybitPositionHandler {

  listen(ws: BybitWebsocketClient) {
    return new Observable<Position>(subscriber => {
      const f = (data: any) => {
        // Проверяем, что это сообщение позиции и только category == 'linear'
        if (isWsPositionEventV5(data)) {
          data.data.filter(row => row.category == 'linear').forEach(row => {
            const position: Position = {
              createdTimestamp: parseIntSafe(row.createdTime),
              updateTimestamp: parseIntSafe(row.updatedTime),
              market: 'bybit',
              board: 'linear',
              symbol: row.symbol,
              entryPrice: row.entryPrice,
              liquidationPrice: row.liqPrice,
              size: row.side == 'Buy' ? row.size : -Math.abs(parseFloatSafe(row.size)),
              positionSide: row.positionIdx == 0 ? PositionSide.both : row.positionIdx == 1 ? PositionSide.long : row.positionIdx == 2 ? PositionSide.short : undefined,
              positionVolume: row.positionValue,
              unrealisedPnl: row.unrealisedPnl,
            }
            subscriber.next(position)
          })
        }
      }

      ws.on('update', f)
      return () => ws.off('update', f)
    })
  }

}
